module.exports = __webpack_public_path__ + "img/icon7.f6d06aa4.png";